// Finite product enum labels. Unknown identifiers retain their readable source fallback.
export const enumMessageKeys: Readonly<Record<string, string>> = {
  safe_retry: 'general.enums.safe_retry',
  follow_up_required: 'general.enums.follow_up_required',
  pause_and_fix: 'general.enums.pause_and_fix',
  rebuild_and_republish: 'general.enums.rebuild_and_republish',
  manual_recovery: 'general.enums.manual_recovery',
  positive: 'general.enums.positive',
  opportunity: 'general.enums.opportunity',
  guest_rsvp: 'general.enums.guest_rsvp',
  form_completion: 'general.enums.form_completion',
  observability: 'general.enums.observability',
  seating: 'general.enums.seating',
  delegated: 'general.enums.delegated',

  'guest.review_access': 'general.tasks.definitions.guest_review_access',
  'guest.complete_rsvp': 'general.tasks.definitions.guest_complete_rsvp',
  'guest.complete_forms': 'general.tasks.definitions.guest_complete_forms',
  'guest.review_schedule': 'general.tasks.definitions.guest_review_schedule',
  'guest.review_seating': 'general.tasks.definitions.guest_review_seating',
  'guest.open_gallery': 'general.tasks.definitions.guest_open_gallery',
  'guest.review_shared_planning':
    'general.tasks.definitions.guest_review_shared_planning',
  'planner.review_campaign':
    'general.tasks.definitions.planner_review_campaign',
  'planner.monitor_automation':
    'general.tasks.definitions.planner_monitor_automation',
  'planner.next_step': 'general.tasks.definitions.planner_next_step',
  'planner.readiness': 'general.tasks.definitions.planner_readiness',
  'planner.resolve_invariant':
    'general.tasks.definitions.planner_resolve_invariant',
  'vendor.confirm_schedule':
    'general.tasks.definitions.vendor_confirm_schedule',
  'vendor.submit_requirements':
    'general.tasks.definitions.vendor_submit_requirements',
  'vendor.upload_assets': 'general.tasks.definitions.vendor_upload_assets',
  'vendor.acknowledge_changes':
    'general.tasks.definitions.vendor_acknowledge_changes',

  save_the_date: 'general.enums.save_the_date',
  schedule_card: 'general.enums.schedule_card',
  table_card: 'general.enums.table_card',
  poster_sign: 'general.enums.poster_sign',
  qr_invitation: 'general.enums.qr_invitation',
  guest_action: 'general.enums.guest_action',
  api_principal_action: 'general.enums.api_principal_action',
  active: 'general.enums.active',
  triggered: 'general.enums.triggered',
  info: 'general.enums.info',
  inactive: 'general.enums.inactive',
  archived: 'general.enums.archived',
  draft: 'general.enums.draft',
  published: 'general.enums.published',
  pending: 'general.enums.pending',
  processing: 'general.enums.processing',
  ready: 'general.enums.ready',
  rejected: 'general.enums.rejected',
  approved: 'general.enums.approved',
  deleted: 'general.enums.deleted',
  image: 'general.enums.image',
  video: 'general.enums.video',
  document: 'general.enums.document',
  pdf: 'general.enums.pdf',
  audio: 'general.enums.audio',
  archive: 'general.enums.archive',
  other: 'general.enums.other',
  guest: 'general.enums.guest',
  vendor: 'general.enums.vendor',
  planner: 'general.enums.planner',
  admin: 'general.enums.admin',
  internal: 'general.enums.internal',
  system: 'general.enums.system',
  user: 'general.enums.user',
  person: 'general.enums.person',
  household: 'general.enums.household',
  group: 'general.enums.group',
  team: 'general.enums.team',
  organization: 'general.enums.organization',
  vendor_organization: 'general.enums.vendor_organization',
  paused: 'general.enums.paused',
  single: 'general.enums.single',
  multiple: 'general.enums.multiple',
  contribution: 'general.enums.contribution',
  submitted: 'general.enums.submitted',
  correction_requested: 'general.enums.correction_requested',
  guest_token: 'general.enums.guest_token',
  claimed_guest: 'general.enums.claimed_guest',
  vendor_portal: 'general.enums.vendor_portal',
  occasion: 'general.enums.occasion',
  event: 'general.enums.event',
  actor: 'general.enums.actor',
  participation: 'general.enums.participation',
  content: 'general.enums.content',
  coordination: 'general.enums.coordination',
  communications: 'general.enums.communications',
  logistics: 'general.enums.logistics',
  commerce: 'general.enums.commerce',
  low: 'general.enums.low',
  medium: 'general.enums.medium',
  high: 'general.enums.high',
  critical: 'general.enums.critical',
  permissions: 'general.enums.permissions',
  rsvp: 'general.enums.rsvp',
  module: 'general.enums.module',
  moderation: 'general.enums.moderation',
  integration: 'general.enums.integration',
  webhook: 'general.enums.webhook',
  publishing: 'general.enums.publishing',
  billing: 'general.enums.billing',
  feature_flag: 'general.enums.feature_flag',
  data_portability: 'general.enums.data_portability',
  user_action: 'general.enums.user_action',
  admin_intervention: 'general.enums.admin_intervention',
  system_action: 'general.enums.system_action',
  scheduled: 'general.enums.scheduled',
  in_progress: 'general.enums.in_progress',
  completed: 'general.enums.completed',
  blocked: 'general.enums.blocked',
  cancelled: 'general.enums.cancelled',
  allow: 'general.enums.allow',
  deny: 'general.enums.deny',
  enabled: 'general.enums.enabled',
  disabled: 'general.enums.disabled',
  revoked: 'general.enums.revoked',
  expired: 'general.enums.expired',
  email: 'general.enums.email',
  sms: 'general.enums.sms',
  whatsapp: 'general.enums.whatsapp',
  phone: 'general.enums.phone',
  push: 'general.enums.push',
  in_app: 'general.enums.in_app',
  automatic: 'general.enums.automatic',
  manual: 'general.enums.manual',
  partially_sent: 'general.enums.partially_sent',
  sent: 'general.enums.sent',
  needs_attention: 'general.enums.needs_attention',
  open: 'general.enums.open',
  claimed: 'general.enums.claimed',
  fulfilled: 'general.enums.fulfilled',
  dish: 'general.enums.dish',
  task: 'general.enums.task',
  ride: 'general.enums.ride',
  custom: 'general.enums.custom',
  completable: 'general.enums.completable',
  informational: 'general.enums.informational',
  planner_only: 'general.enums.planner_only',
  invited_guests: 'general.enums.invited_guests',
  selected_actors: 'general.enums.selected_actors',
  bride: 'general.enums.bride',
  groom: 'general.enums.groom',
  host: 'general.enums.host',
  family_a: 'general.enums.family_a',
  family_b: 'general.enums.family_b',
  attending: 'general.enums.attending',
  not_coming: 'general.enums.not_coming',
  declined: 'general.enums.declined',
  rsvped: 'general.enums.rsvped',
  hidden: 'general.enums.hidden',
  public: 'general.enums.public',
  private: 'general.enums.private',
  guest_visible: 'general.enums.guest_visible',
  guests_visible: 'general.enums.guests_visible',
  planner_visible: 'general.enums.planner_visible',
  all_event_guests: 'general.enums.all_event_guests',
  invited_event_guest: 'general.enums.invited_event_guest',
  invited_guest: 'general.enums.invited_guest',
  anyone_with_link: 'general.enums.anyone_with_link',
  released: 'general.enums.released',
  confirmed: 'general.enums.confirmed',
  unconfirmed: 'general.enums.unconfirmed',
  queued: 'general.enums.queued',
  sent_to_provider: 'general.enums.sent_to_provider',
  delivered: 'general.enums.delivered',
  opened: 'general.enums.opened',
  clicked: 'general.enums.clicked',
  retry_pending: 'general.enums.retry_pending',
  retry_scheduled: 'general.enums.retry_scheduled',
  permanently_failed: 'general.enums.permanently_failed',
  failed: 'general.enums.failed',
  suppressed: 'general.enums.suppressed',
  bounced: 'general.enums.bounced',
  uncontacted: 'general.enums.uncontacted',
  invited: 'general.enums.invited',
  responded: 'general.enums.responded',
  checked_in: 'general.enums.checked_in',
  checked_out: 'general.enums.checked_out',
  male: 'general.enums.male',
  female: 'general.enums.female',
  unspecified: 'general.enums.unspecified',
  non_binary: 'general.enums.non_binary',
  parent: 'general.enums.parent',
  child: 'general.enums.child',
  spouse: 'general.enums.spouse',
  sibling: 'general.enums.sibling',
  friend: 'general.enums.friend',
  relative: 'general.enums.relative',
  partner: 'general.enums.partner',
  member: 'general.enums.member',
  owner: 'general.enums.owner',
  primary: 'general.enums.primary',
  secondary: 'general.enums.secondary',
  required: 'general.enums.required',
  optional: 'general.enums.optional',
  complete: 'general.enums.complete',
  incomplete: 'general.enums.incomplete',
  attention: 'general.enums.attention',
  unavailable: 'general.enums.unavailable',
  not_started: 'general.enums.not_started',
  not_scheduled: 'general.enums.not_scheduled',
  not_applicable: 'general.enums.not_applicable',
  setup: 'general.enums.setup',
  planning: 'general.enums.planning',
  pre_event: 'general.enums.pre_event',
  live: 'general.enums.live',
  wrap_up: 'general.enums.wrap_up',
  closed: 'general.enums.closed',
  provisioned: 'general.enums.provisioned',
  suspended: 'general.enums.suspended',
  healthy: 'general.enums.healthy',
  degraded: 'general.enums.degraded',
  failing: 'general.enums.failing',
  error: 'general.enums.error',
  warning: 'general.enums.warning',
  success: 'general.enums.success',
  normal: 'general.enums.normal',
  platform: 'general.enums.platform',
  module_installation: 'general.enums.module_installation',
  module_enablement: 'general.enums.module_enablement',
  resource: 'general.enums.resource',
  created: 'general.enums.created',
  updated: 'general.enums.updated',
  removed: 'general.enums.removed',
  assigned: 'general.enums.assigned',
  unassigned: 'general.enums.unassigned',
  created_by_planner: 'general.enums.created_by_planner',
  admin_created: 'general.enums.admin_created',
  imported: 'general.enums.imported',
  self_service: 'general.enums.self_service',
  venue: 'general.enums.venue',
  accommodation: 'general.enums.accommodation',
  parking: 'general.enums.parking',
  transportation_point: 'general.enums.transportation_point',
  point_of_interest: 'general.enums.point_of_interest',
  internal_venue_point: 'general.enums.internal_venue_point',
  maps: 'general.enums.maps',
  website: 'general.enums.website',
  navigation: 'general.enums.navigation',
  payment: 'general.enums.payment',
  cash: 'general.enums.cash',
  credit_card: 'general.enums.credit_card',
  bank_transfer: 'general.enums.bank_transfer',
  check: 'general.enums.check',
  paid: 'general.enums.paid',
  partially_paid: 'general.enums.partially_paid',
  unpaid: 'general.enums.unpaid',
  overdue: 'general.enums.overdue',
  due: 'general.enums.due',
  estimated: 'general.enums.estimated',
  committed: 'general.enums.committed',
  planned: 'general.enums.planned',
  text: 'general.enums.text',
  textarea: 'general.enums.textarea',
  number: 'general.enums.number',
  boolean: 'general.enums.boolean',
  date: 'general.enums.date',
  select: 'general.enums.select',
  multi_select: 'general.enums.multi_select',
  file: 'general.enums.file',
  url: 'general.enums.url',
  link: 'general.enums.link',
  all: 'general.enums.all',
  none: 'general.enums.none',
  both: 'general.enums.both',
  install: 'general.enums.install',
  enable: 'general.enums.enable',
  runtime: 'general.enums.runtime',
  validation: 'general.enums.validation',
  uninstalled: 'general.enums.uninstalled',
  installed: 'general.enums.installed',
  missing: 'general.enums.missing',
  available: 'general.enums.available',
  accepted: 'general.enums.accepted',
  maybe: 'general.enums.maybe',
  not_responded: 'general.enums.not_responded',
  partial: 'general.enums.partial',
  post_moderation: 'general.enums.post_moderation',
  pre_moderation: 'general.enums.pre_moderation',
  planner_detailed: 'general.enums.planner_detailed',
  guest_summary: 'general.enums.guest_summary',
  numbers: 'general.enums.numbers',
  names: 'general.enums.names',
  hybrid: 'general.enums.hybrid',
  single_claim: 'general.enums.single_claim',
  multi_claim: 'general.enums.multi_claim',
  enhanced: 'general.enums.enhanced',
  basic: 'general.enums.basic',
  base: 'general.enums.base',
  standard: 'general.enums.standard',
  full: 'general.enums.full',
  access: 'general.enums.access',
  access_revoked: 'general.enums.access_revoked',
  account: 'general.enums.account',
  acknowledged: 'general.enums.acknowledged',
  action_required: 'general.enums.action_required',
  actor_group_specific: 'general.enums.actor_group_specific',
  actor_not_in_group: 'general.enums.actor_not_in_group',
  actor_preference: 'general.enums.actor_preference',
  added_by_recipient: 'general.enums.added_by_recipient',
  admin_only: 'general.enums.admin_only',
  admin_view: 'general.enums.admin_view',
  admin_visible_context: 'general.enums.admin_visible_context',
  advance: 'general.enums.advance',
  agency_account: 'general.enums.agency_account',
  agent_principal: 'general.enums.agent_principal',
  ai: 'general.enums.ai',
  api: 'general.enums.api',
  api_access: 'general.enums.api_access',
  api_key: 'general.enums.api_key',
  api_principal: 'general.enums.api_principal',
  assigned_vendor: 'general.enums.assigned_vendor',
  attending_active: 'general.enums.attending_active',
  attending_upcoming: 'general.enums.attending_upcoming',
  authenticated_guest_only: 'general.enums.authenticated_guest_only',
  automation: 'general.enums.automation',
  awaiting_confirmation: 'general.enums.awaiting_confirmation',
  billing_locked: 'general.enums.billing_locked',
  campaign: 'general.enums.campaign',
  collaboration: 'general.enums.collaboration',
  completed_with_errors: 'general.enums.completed_with_errors',
  completed_with_failures: 'general.enums.completed_with_failures',
  converted: 'general.enums.converted',
  cross_cutting: 'general.enums.cross_cutting',
  cross_domain: 'general.enums.cross_domain',
  default: 'general.enums.default',
  delivery_failed: 'general.enums.delivery_failed',
  derived: 'general.enums.derived',
  derived_from_source_state: 'general.enums.derived_from_source_state',
  desktop: 'general.enums.desktop',
  development: 'general.enums.development',
  dismissed: 'general.enums.dismissed',
  distribution: 'general.enums.distribution',
  due_soon: 'general.enums.due_soon',
  entry: 'general.enums.entry',
  events: 'general.enums.events',
  exit: 'general.enums.exit',
  expired_distribution: 'general.enums.expired_distribution',
  expired_mid_flow: 'general.enums.expired_mid_flow',
  expiring_soon: 'general.enums.expiring_soon',
  explicit: 'general.enums.explicit',
  explicit_request: 'general.enums.explicit_request',
  explicit_resolution: 'general.enums.explicit_resolution',
  explicitly_excluded: 'general.enums.explicitly_excluded',
  failure: 'general.enums.failure',
  faq: 'general.enums.faq',
  feature_disabled: 'general.enums.feature_disabled',
  finance: 'general.enums.finance',
  finish_to_start: 'general.enums.finish_to_start',
  first_entry: 'general.enums.first_entry',
  form: 'general.enums.form',
  forms: 'general.enums.forms',
  forms_pending: 'general.enums.forms_pending',
  gallery: 'general.enums.gallery',
  generic_link: 'general.enums.generic_link',
  guest_experience: 'general.enums.guest_experience',
  guest_invitation: 'general.enums.guest_invitation',
  guest_optional: 'general.enums.guest_optional',
  guest_principal: 'general.enums.guest_principal',
  guest_view: 'general.enums.guest_view',
  guest_visible_context: 'general.enums.guest_visible_context',
  guestbook: 'general.enums.guestbook',
  hard_block: 'general.enums.hard_block',
  http: 'general.enums.http',
  http_api: 'general.enums.http_api',
  identified_or_resolved: 'general.enums.identified_or_resolved',
  identified_pending_response: 'general.enums.identified_pending_response',
  important: 'general.enums.important',
  initialized: 'general.enums.initialized',
  integration_action: 'general.enums.integration_action',
  integration_principal: 'general.enums.integration_principal',
  integrations: 'general.enums.integrations',
  invalid: 'general.enums.invalid',
  invalidated: 'general.enums.invalidated',
  invitation: 'general.enums.invitation',
  invite_ready: 'general.enums.invite_ready',
  invited_and_eligible_guest_only:
    'general.enums.invited_and_eligible_guest_only',
  joined_via_link: 'general.enums.joined_via_link',
  journey_event: 'general.enums.journey_event',
  lifecycle_independent: 'general.enums.lifecycle_independent',
  link_clicked: 'general.enums.link_clicked',
  live_event: 'general.enums.live_event',
  localization: 'general.enums.localization',
  manual_selection: 'general.enums.manual_selection',
  manual_send_opened: 'general.enums.manual_send_opened',
  manually_sent: 'general.enums.manually_sent',
  missing_actor_reference: 'general.enums.missing_actor_reference',
  missing_channel: 'general.enums.missing_channel',
  mobile: 'general.enums.mobile',
  module_runtime: 'general.enums.module_runtime',
  mostly_public: 'general.enums.mostly_public',
  multi_language: 'general.enums.multi_language',
  needs_review: 'general.enums.needs_review',
  new_link_available: 'general.enums.new_link_available',
  not_enabled: 'general.enums.not_enabled',
  not_tracked: 'general.enums.not_tracked',
  occasion_default: 'general.enums.occasion_default',
  occasion_guest: 'general.enums.occasion_guest',
  occasion_location: 'general.enums.occasion_location',
  onboarding: 'general.enums.onboarding',
  opened_access: 'general.enums.opened_access',
  package: 'general.enums.package',
  package_required: 'general.enums.package_required',
  parsing: 'general.enums.parsing',
  partially_completed: 'general.enums.partially_completed',
  passed_with_warnings: 'general.enums.passed_with_warnings',
  pending_delivery: 'general.enums.pending_delivery',
  pending_manual_send: 'general.enums.pending_manual_send',
  pending_removal: 'general.enums.pending_removal',
  permission_denied: 'general.enums.permission_denied',
  planner_internal_only: 'general.enums.planner_internal_only',
  planner_view: 'general.enums.planner_view',
  planner_visible_context: 'general.enums.planner_visible_context',
  post_event: 'general.enums.post_event',
  pre_event_operational: 'general.enums.pre_event_operational',
  pre_event_ready: 'general.enums.pre_event_ready',
  preflight: 'general.enums.preflight',
  principal: 'general.enums.principal',
  principal_api_key: 'general.enums.principal_api_key',
  private_token_only: 'general.enums.private_token_only',
  production: 'general.enums.production',
  public_landing_private_content:
    'general.enums.public_landing_private_content',
  public_visitor: 'general.enums.public_visitor',
  re_created: 'general.enums.re_created',
  re_entry_possible: 'general.enums.re_entry_possible',
  reconciliation_required: 'general.enums.reconciliation_required',
  regenerated: 'general.enums.regenerated',
  registry: 'general.enums.registry',
  registry_item: 'general.enums.registry_item',
  resolved: 'general.enums.resolved',
  responded_active: 'general.enums.responded_active',
  review: 'general.enums.review',
  review_recommended: 'general.enums.review_recommended',
  revoked_distribution: 'general.enums.revoked_distribution',
  revoked_mid_flow: 'general.enums.revoked_mid_flow',
  revoked_or_invalid: 'general.enums.revoked_or_invalid',
  rotated: 'general.enums.rotated',
  rsvp_accepted_guest: 'general.enums.rsvp_accepted_guest',
  rsvp_already_completed: 'general.enums.rsvp_already_completed',
  rsvp_completed: 'general.enums.rsvp_completed',
  rsvp_in_progress: 'general.enums.rsvp_in_progress',
  rsvp_invitation: 'general.enums.rsvp_invitation',
  rsvp_submitted: 'general.enums.rsvp_submitted',
  running: 'general.enums.running',
  segment_filtered: 'general.enums.segment_filtered',
  session_expired: 'general.enums.session_expired',
  session_recovered: 'general.enums.session_recovered',
  setup_in_progress: 'general.enums.setup_in_progress',
  shared_planning: 'general.enums.shared_planning',
  shared_planning_board: 'general.enums.shared_planning_board',
  shared_planning_item: 'general.enums.shared_planning_item',
  shown: 'general.enums.shown',
  skip_existing: 'general.enums.skip_existing',
  skipped: 'general.enums.skipped',
  start_to_start: 'general.enums.start_to_start',
  succeeded: 'general.enums.succeeded',
  support: 'general.enums.support',
  system_default: 'general.enums.system_default',
  system_principal: 'general.enums.system_principal',
  target_reached: 'general.enums.target_reached',
  terminal: 'general.enums.terminal',
  timeline: 'general.enums.timeline',
  timeline_item: 'general.enums.timeline_item',
  travel: 'general.enums.travel',
  update_matching: 'general.enums.update_matching',
  updates: 'general.enums.updates',
  user_principal: 'general.enums.user_principal',
  validating: 'general.enums.validating',
  vendor_access: 'general.enums.vendor_access',
  vendor_confirmations: 'general.enums.vendor_confirmations',
  vendor_role_specific: 'general.enums.vendor_role_specific',
  vendor_view: 'general.enums.vendor_view',
  vendor_visible_context: 'general.enums.vendor_visible_context',
  vendor_workspace: 'general.enums.vendor_workspace',
  webhooks: 'general.enums.webhooks',
  workload_principal: 'general.enums.workload_principal',
};
